import React from "react";
import styled, { ThemeProvider } from "styled-components";
import { motion } from "framer-motion";
import { DarkTheme } from "./Themes";

import LogoComponent from "../subComponents/LogoComponent";
import SocialIcons from "../subComponents/SocialIcons";
import PowerButton from "../subComponents/PowerButton";
import ParticleComponent from "../subComponents/ParticleComponent";
import BigTitle from "../subComponents/BigTitlte";
import astronaut from "../assets/Images/appu-full-cover.png";

/* ================= PAGE WRAPPER ================= */

const Box = styled.div`
  background-color: ${(props) => props.theme.body};
  width: 100vw;
  height: 100vh;
  position: relative;
  overflow: hidden;

  display: flex;
  justify-content: center;
  align-items: center;
`;


/* ================= SPACEMAN ================= */

const Spaceman = styled(motion.div)`
  position: absolute;
  top: 16%;
  right: 1%;
  width: 30vw;
  z-index: 5;

  img {
    width: 100%;
    height: auto;
  }
`;

/* ================= TEXT BOX ================= */

const Main = styled(motion.div)`
  border: 2px solid ${(props) => props.theme.text};
  color: ${(props) => props.theme.text};
  padding: 2rem;
  width: 50vw;
  max-width: 700px;
  z-index: 3;
  line-height: 1.6;

  font-size: calc(0.6rem + 1vw);
  background: rgba(0, 0, 0, 0.6);

  font-family: "Ubuntu Mono", monospace;
  font-style: italic;
  text-align: center;

  position: relative;
  top: 4rem;
`;

/* ================= ANIMATIONS ================= */

const textAnimation = {
  hidden: { 
    opacity: 0,
    scale: 0.85
  },
  show: {
    opacity: 1,
    scale: 1,
    transition: {
      delay: 1,
      duration: 0.6,
      ease: [0.65, 0, 0.35, 1],
    },
  },
};

const spacemanAnimation = {
  hidden: { opacity: 0, y: -60 },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      delay: 1.2,
      duration: 1.5,
      ease: [0.65, 0, 0.35, 1],
    },
  },
};

/* ================= COMPONENT ================= */

const AboutPage = () => {
  return (
    <ThemeProvider theme={DarkTheme}>
      <Box>
        <LogoComponent theme="dark" />
        <SocialIcons theme="dark" />
        <PowerButton />
        <ParticleComponent theme="dark" />

        {/* Spaceman appears last */}
        <Spaceman
          variants={spacemanAnimation}
          initial="hidden"
          animate="show"
        >
          <motion.img
            src={astronaut}
            alt="spaceman"
            animate={{ y: [0, -15, 0] }}
            transition={{ repeat: Infinity, duration: 4 }}
          />
        </Spaceman>

        {/* Text box appears second */}
       <Main
  variants={textAnimation}
  initial="hidden"
  animate="show"
>
  I'm a Frontend & MERN Stack developer based in India. I build modern,
  scalable web applications with clean architecture and strong attention to detail.
  <br />
  <br />
  I enjoy turning complex problems into simple, intuitive solutions
  through structured code and thoughtful design decisions.
  <br />
  <br />
  I'm always learning and pushing myself to build products that
  create real-world impact.
</Main>

        <BigTitle text="ABOUT" top="10%" left="5%" />
      </Box>
    </ThemeProvider>
  );
};

export default AboutPage;